module.exports = __webpack_public_path__ + "img/zsyh.aa42ee8f.png";